import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { adminInstance as admin, toastError } from '~/utils';

const RevealActivationCodeModal = ({ isOpen, toggle, userUid }) => {
  const [smsCode, setSmsCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setSmsCode(null);
      setLoading(true);
      setCopied(false);
      return;
    }

    admin
      .post('/send-user-activation-with-reveal', { 'user-uid': userUid })
      .then(res => {
        setSmsCode(res.data.data.smsCode);
      })
      .catch(toastError)
      .finally(() => setLoading(false));
  }, [isOpen, userUid]);

  const handleCopy = () => {
    if (smsCode) {
      navigator.clipboard.writeText(smsCode).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false}>
      <ModalHeader toggle={toggle}>Activation Code</ModalHeader>

      <ModalBody>
        {smsCode && (
          <>
            <p className="text-muted mb-2">
              Read this code to the user. It will not be shown again.
            </p>
            <InputGroup>
              <Input
                readOnly
                value={smsCode}
                style={{
                  fontSize: '1.5rem',
                  letterSpacing: '0.2em',
                  fontWeight: 'bold',
                }}
              />
              <InputGroupAddon addonType="append">
                <Button color="secondary" onClick={handleCopy}>
                  {copied ? 'Copied!' : 'Copy'}
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </>
        )}
        {!smsCode && loading && <p className="text-muted">Loading&hellip;</p>}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

RevealActivationCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  userUid: PropTypes.string.isRequired,
};

export default RevealActivationCodeModal;
